<template>
	<div>
		<!-- 面包屑导航区域 -->		
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 缓存统计区域 -->
			<el-row :gutter="20" style="margin-bottom: 20px;">
				<el-col :span="6">
					<el-card shadow="hover" class="stat-card">
						<div class="stat-content">
							<div class="stat-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
								<i class="el-icon-location-outline"></i>
							</div>
							<div class="stat-info">
								<div class="stat-value">{{ cacheStats.fenceCount || 0 }}</div>
								<div class="stat-label">电子围栏</div>
							</div>
						</div>
						<div class="stat-ttl" v-if="cacheStats.fenceTtl > 0">剩余 {{ formatTtl(cacheStats.fenceTtl) }}</div>
						<div class="stat-ttl" v-else>永久有效</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card shadow="hover" class="stat-card">
						<div class="stat-content">
							<div class="stat-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
								<i class="el-icon-lock"></i>
							</div>
							<div class="stat-info">
								<div class="stat-value">{{ cacheStats.lockCount || 0 }}</div>
								<div class="stat-label">车锁设备</div>
							</div>
						</div>
						<div class="stat-ttl" v-if="cacheStats.lockTtl > 0">剩余 {{ formatTtl(cacheStats.lockTtl) }}</div>
						<div class="stat-ttl" v-else>永久有效</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card shadow="hover" class="stat-card">
						<div class="stat-content">
							<div class="stat-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
								<i class="el-icon-setting"></i>
							</div>
							<div class="stat-info">
								<div class="stat-value">{{ cacheStats.settingCount || 0 }}</div>
								<div class="stat-label">运营商配置</div>
							</div>
						</div>
						<div class="stat-ttl" v-if="cacheStats.settingTtl > 0">剩余 {{ formatTtl(cacheStats.settingTtl) }}</div>
						<div class="stat-ttl" v-else>永久有效</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card shadow="hover" class="stat-card">
						<div class="stat-content">
							<div class="stat-icon" style="background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);">
								<i class="el-icon-office-building"></i>
							</div>
							<div class="stat-info">
								<div class="stat-value">{{ cacheStats.distributorCount || 0 }}</div>
								<div class="stat-label">运营商信息</div>
							</div>
						</div>
						<div class="stat-ttl" v-if="cacheStats.distributorTtl > 0">剩余 {{ formatTtl(cacheStats.distributorTtl) }}</div>
						<div class="stat-ttl" v-else>永久有效</div>
					</el-card>
				</el-col>
			</el-row>
			
			<!-- 操作按钮区域 -->
			<el-row :gutter="20" style="margin-bottom: 20px;">
				<el-col :span="24">
					<el-button type="primary" icon="el-icon-refresh" @click="refreshAllCache" :loading="refreshing">刷新所有缓存</el-button>
					<el-button type="danger" icon="el-icon-delete" @click="clearAllCache" :loading="clearing">清除所有缓存</el-button>
					<el-button type="success" icon="el-icon-refresh" @click="loadCacheStats" :loading="loading">刷新统计</el-button>
				</el-col>
			</el-row>
			
			<!-- 缓存操作卡片 -->
			<el-row :gutter="20">
				<el-col :span="8">
					<el-card class="cache-card">
						<div slot="header" class="card-header">
							<span><i class="el-icon-location-outline"></i> 电子围栏缓存</span>
						</div>
						<div class="card-content">
							<p>缓存所有有效的电子围栏数据，包括围栏坐标、名称等信息。</p>
							<el-button type="primary" size="small" icon="el-icon-refresh" @click="refreshFenceCache" :loading="fenceRefreshing">刷新缓存</el-button>
						</div>
					</el-card>
				</el-col>
				<el-col :span="8">
					<el-card class="cache-card">
						<div slot="header" class="card-header">
							<span><i class="el-icon-lock"></i> 车锁设备缓存</span>
						</div>
						<div class="card-content">
							<p>缓存所有有效的车锁设备数据，包括设备编号、位置等信息。</p>
							<el-button type="primary" size="small" icon="el-icon-refresh" @click="refreshLockCache" :loading="lockRefreshing">刷新缓存</el-button>
						</div>
					</el-card>
				</el-col>
				<el-col :span="8">
					<el-card class="cache-card">
						<div slot="header" class="card-header">
							<span><i class="el-icon-setting"></i> 运营商配置缓存</span>
						</div>
						<div class="card-content">
							<p>缓存运营商的计费配置、押金设置、调度费等信息。</p>
							<el-button type="primary" size="small" icon="el-icon-refresh" @click="refreshSettingCache" :loading="settingRefreshing">刷新缓存</el-button>
						</div>
					</el-card>
				</el-col>
			</el-row>
			
			<el-row :gutter="20" style="margin-top: 20px;">
				<el-col :span="8">
					<el-card class="cache-card">
						<div slot="header" class="card-header">
							<span><i class="el-icon-office-building"></i> 运营商信息缓存</span>
						</div>
						<div class="card-content">
							<p>缓存所有有效的运营商基本信息数据。</p>
							<el-button type="primary" size="small" icon="el-icon-refresh" @click="refreshDistributorCache" :loading="distributorRefreshing">刷新缓存</el-button>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
export default {
	name: 'CacheManage',
	data() {
		return {
			loading: false,
			refreshing: false,
			clearing: false,
			fenceRefreshing: false,
			lockRefreshing: false,
			settingRefreshing: false,
			distributorRefreshing: false,
			cacheStats: {
				fenceCount: 0,
				lockCount: 0,
				settingCount: 0,
				distributorCount: 0,
				fenceTtl: 0,
				lockTtl: 0,
				settingTtl: 0,
				distributorTtl: 0
			}
		}
	},
	created() {
		this.loadCacheStats()
	},
	methods: {
		async loadCacheStats() {
			this.loading = true
			try {
				const { data: res } = await this.$http.get('/api/cache/stats')
				if (res.code !== 200) {
					this.$message.error('获取缓存统计失败')
					return
				}
				this.cacheStats = res.data || {}
			} catch (error) {
				this.$message.error('获取缓存统计失败')
			} finally {
				this.loading = false
			}
		},
		
		async refreshAllCache() {
			this.refreshing = true
			try {
				const { data: res } = await this.$http.post('/api/cache/refresh/all')
				if (res.code !== 200) {
					this.$message.error(res.msg || '缓存刷新失败')
					return
				}
				this.$message.success(res.msg || '缓存刷新成功')
				this.loadCacheStats()
			} catch (error) {
				this.$message.error('缓存刷新失败')
			} finally {
				this.refreshing = false
			}
		},
		
		async clearAllCache() {
			try {
				await this.$confirm('确定要清除所有缓存吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				
				this.clearing = true
				const { data: res } = await this.$http.post('/api/cache/clear/all')
				if (res.code !== 200) {
					this.$message.error(res.msg || '缓存清除失败')
					return
				}
				this.$message.success(res.msg || '缓存清除成功')
				this.loadCacheStats()
			} catch (error) {
				if (error !== 'cancel') {
					this.$message.error('缓存清除失败')
				}
			} finally {
				this.clearing = false
			}
		},
		
		async refreshFenceCache() {
			this.fenceRefreshing = true
			try {
				const { data: res } = await this.$http.post('/api/cache/refresh/fence')
				if (res.code !== 200) {
					this.$message.error(res.msg || '电子围栏缓存刷新失败')
					return
				}
				this.$message.success(res.msg || '电子围栏缓存刷新成功')
				this.loadCacheStats()
			} catch (error) {
				this.$message.error('电子围栏缓存刷新失败')
			} finally {
				this.fenceRefreshing = false
			}
		},
		
		async refreshLockCache() {
			this.lockRefreshing = true
			try {
				const { data: res } = await this.$http.post('/api/cache/refresh/lock')
				if (res.code !== 200) {
					this.$message.error(res.msg || '车锁设备缓存刷新失败')
					return
				}
				this.$message.success(res.msg || '车锁设备缓存刷新成功')
				this.loadCacheStats()
			} catch (error) {
				this.$message.error('车锁设备缓存刷新失败')
			} finally {
				this.lockRefreshing = false
			}
		},
		
		async refreshSettingCache() {
			this.settingRefreshing = true
			try {
				const { data: res } = await this.$http.post('/api/cache/refresh/distributorSetting')
				if (res.code !== 200) {
					this.$message.error(res.msg || '运营商配置缓存刷新失败')
					return
				}
				this.$message.success(res.msg || '运营商配置缓存刷新成功')
				this.loadCacheStats()
			} catch (error) {
				this.$message.error('运营商配置缓存刷新失败')
			} finally {
				this.settingRefreshing = false
			}
		},
		
		async refreshDistributorCache() {
			this.distributorRefreshing = true
			try {
				const { data: res } = await this.$http.post('/api/cache/refresh/distributor')
				if (res.code !== 200) {
					this.$message.error(res.msg || '运营商信息缓存刷新失败')
					return
				}
				this.$message.success(res.msg || '运营商信息缓存刷新成功')
				this.loadCacheStats()
			} catch (error) {
				this.$message.error('运营商信息缓存刷新失败')
			} finally {
				this.distributorRefreshing = false
			}
		},
		
		formatTtl(seconds) {
			if (seconds <= 0) return '已过期'
			const days = Math.floor(seconds / (24 * 60 * 60))
			const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60))
			if (days > 0) {
				return `${days}天${hours}小时`
			}
			return `${hours}小时`
		}
	}
}
</script>

<style scoped>
.stat-card {
	border-radius: 10px;
}

.stat-content {
	display: flex;
	align-items: center;
}

.stat-icon {
	width: 60px;
	height: 60px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 15px;
}

.stat-icon i {
	font-size: 28px;
	color: white;
}

.stat-info {
	flex: 1;
}

.stat-value {
	font-size: 28px;
	font-weight: bold;
	color: #303133;
}

.stat-label {
	font-size: 14px;
	color: #909399;
	margin-top: 5px;
}

.stat-ttl {
	font-size: 12px;
	color: #909399;
	margin-top: 10px;
	text-align: right;
}

.cache-card {
	height: 180px;
}

.card-header {
	font-weight: bold;
	font-size: 16px;
}

.card-header i {
	margin-right: 8px;
	color: #409EFF;
}

.card-content {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100px;
}

.card-content p {
	color: #606266;
	font-size: 14px;
	line-height: 1.6;
	margin: 0;
}
</style>
